export default "__VITE_ASSET__BkmZcV$c__";